import {combineReducers} from 'redux';
import errorsReducer from './errorsReducer';
import requestingReducer from './requestingReducer';
import sessionsReducer from './sessionsReducer';
import ordersReducer from './ordersReducer';
import inquiriesReducer from './inquiriesReducer';
import contactsReducer from './contactsReducer';
import productsReducer from './productsReducer';

export default combineReducers({
    errors: errorsReducer,
    requesting: requestingReducer,
    sessions: sessionsReducer,
    orders: ordersReducer,
    inquiries: inquiriesReducer,
    contacts: contactsReducer,
    products: productsReducer
})